import React from "react";
import { toCount, formatPercent, sumRows, averagePercent } from "./utils";

export default function TableComponent({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) {
  const levelLower = String(currentLevel || "").toLowerCase();
  const isNational = levelLower === "national";
  const isProvince = levelLower === "province";

  let levelName = "";
  if (isNational) {
    levelName = "Nasional";
  } else if (isProvince) {
    levelName = "Provinsi";
  } else if (levelLower === "district") {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  const faskesName = (() => {
    const data = reportInfo?.fasyankes;
    if (!data) return "Semua Fasyankes";
    const parts = data.split(",");
    const names = parts.map((part) => part?.split("|")[1] || part);
    return names.join(", ");
  })();

  const regionColsCount = isNational ? 4 : isProvince ? 3 : 2;
  const allColumnsCount = 1 + regionColsCount + 11;
  const totalLabelSpan = 1 + regionColsCount;

  const dataRows = reportsData ?? [];
  const totals = sumRows(dataRows);

  const useAverage = isNational || isProvince;
  const totalIndeksHabitat = useAverage
    ? averagePercent(dataRows, "positif_jentik", "status_masih_ada")
    : totals.indeks_habitat;
  const totalCakupan = useAverage
    ? averagePercent(dataRows, "sudah_intervensi", "positif_jentik")
    : totals.cakupan_intervensi;

  return (
    <div className="table-table-responsive" ref={tableRef}>
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", paddingBottom: "0" }}>
              <h3>SISMAL v3, LAPORAN REKAP 1 DATA PEMANTAUAN JENTIK</h3>
            </th>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th
              width="200"
              style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
            >
              Periode Laporan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.statusPeriode || "-"}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Periode
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.periode || "-"}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Level
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {levelName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Provinsi
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.province
                ? "Semua Provinsi"
                : reportInfo?.province?.split("|")[1] || reportInfo?.province}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Kab/Kota
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.district
                ? "Semua Kab/Kota"
                : reportInfo?.district?.split("|")[1] || reportInfo?.district}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
            <th style={{ border: "none", paddingTop: 0 }}>: {faskesName}</th>
          </tr>
        </tbody>
      </table>

      <table>
        <thead>
          <tr>
            <th>No.</th>
            {isNational && <th>Provinsi</th>}
            {(isNational || isProvince) && <th>Kabupaten/Kota</th>}
            <th>Fasyankes</th>
            <th>Desa</th>
            <th>Jumlah Tempat Perindukan Disurvei</th>
            <th>Status TP (Masih Ada)</th>
            <th>Status TP (Tidak Ada)</th>
            <th>Status TP Tidak Ada (Karena Intervensi)</th>
            <th>Status TP Tidak Ada (Bukan Karena Intervensi)</th>
            <th>Positif Jentik Anopheles</th>
            <th>Negatif Jentik</th>
            <th>Sudah Diintervensi</th>
            <th>Belum Diintervensi</th>
            <th>Indeks Habitat</th>
            <th>Cakupan Intervensi</th>
          </tr>
        </thead>
        <tbody>
          {dataRows.length ? (
            dataRows.map((row, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                {isNational && <td>{row?.provinsi ?? "-"}</td>}
                {(isNational || isProvince) && <td>{row?.kabupaten ?? "-"}</td>}
                <td>{row?.fasyankes ?? "-"}</td>
                <td>{row?.desa ?? "-"}</td>
                <td>{toCount(row?.jumlah_tp_disurvei)}</td>
                <td>{toCount(row?.status_masih_ada)}</td>
                <td>{toCount(row?.status_tidak_ada)}</td>
                <td>{toCount(row?.tidak_ada_karena_intervensi)}</td>
                <td>{toCount(row?.tidak_ada_bukan_karena_intervensi)}</td>
                <td>{toCount(row?.positif_jentik)}</td>
                <td>{toCount(row?.negatif_jentik)}</td>
                <td>{toCount(row?.sudah_intervensi)}</td>
                <td>{toCount(row?.belum_intervensi)}</td>
                <td>
                  {formatPercent(row?.positif_jentik, row?.status_masih_ada)}
                </td>
                <td>
                  {formatPercent(row?.sudah_intervensi, row?.positif_jentik)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={allColumnsCount}>Tidak Ada Data</td>
            </tr>
          )}
        </tbody>
        {dataRows.length > 0 && (
          <tfoot>
            <tr
              style={{
                fontWeight: "bold",
                backgroundColor: "#43766C",
              }}
            >
              <td style={{ color: "#FFF" }} colSpan={totalLabelSpan}>
                Total
              </td>
              <td style={{ color: "#FFF" }}>{totals.jumlah_tp_disurvei}</td>
              <td style={{ color: "#FFF" }}>{totals.status_masih_ada}</td>
              <td style={{ color: "#FFF" }}>{totals.status_tidak_ada}</td>
              <td style={{ color: "#FFF" }}>
                {totals.tidak_ada_karena_intervensi}
              </td>
              <td style={{ color: "#FFF" }}>
                {totals.tidak_ada_bukan_karena_intervensi}
              </td>
              <td style={{ color: "#FFF" }}>{totals.positif_jentik}</td>
              <td style={{ color: "#FFF" }}>{totals.negatif_jentik}</td>
              <td style={{ color: "#FFF" }}>{totals.sudah_intervensi}</td>
              <td style={{ color: "#FFF" }}>{totals.belum_intervensi}</td>
              <td style={{ color: "#FFF" }}>{totalIndeksHabitat}</td>
              <td style={{ color: "#FFF" }}>{totalCakupan}</td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}
